import { phoneNumberValidator } from "validators";
import * as yup from "yup";

const dispatchValidator = yup
  .object({
    passenger_first_name: yup
      .string()
      .required("Passenger first name is required"),
    passenger_last_name: yup
      .string()
      .required("Passenger last name is required"),
    passenger_phone: yup
      .string()
      .required("Passenger Phone Number is required")
      .test(
        "phone-validator",
        "Invalid phone number format. e.g. 912345678",
        phoneNumberValidator
      ),
    fleet_model_id: yup.string().required("Fleet model is required"),
    pickup_location: yup.string().required("Pickup location is required"),
    drop_off_location: yup.string().required("Drop off location is required"),
    pickup_latitude: yup
      .number()
      .typeError("Pickup location is required")
      .required("Pickup location is required"),
    pickup_longitude: yup
      .number()
      .typeError("Pickup location is required")
      .required("Pickup location is required"),
    drop_off_latitude: yup
      .number()
      .typeError("Drop off location is required")
      .required("Drop off location is required"),
    drop_off_longitude: yup
      .number()
      .typeError("Drop off location is required")
      .required("Drop off location is required"),
    driver_id: yup.string().nullable(),
  })
  .required();

export default dispatchValidator;
